// src/translations.js
export const translations = {
   
    wlc:{ title:{
        fr: "Viens creuser avec nous !",
        de: "Grab dich rein!",
        it: "Preparati a scavare!",
      },
      description:{
        fr: "Avant de partir au ciné, plonge dans l’univers de A Minecraft Movie Meal pour découvrir des figurines à collectionner exclusives, les skins et bien plus encore. ",
        de: "Bevor du im Kino verschwindest, grab dich in die Welt von A Minecraft Movie Meal für exklusive Sammelfiguren, In-Game-Skins und vielem mehr.",
        it: "Prima di scomparire al cinema, scava nel mondo di A Minecraft Movie Meal con esclusivi personaggi da collezionare, in-game skin e molto altro. ",
    },
    select:{
        fr: "Sélectionne un article ci-dessous pour en savoir plus. ",
        de: "Wähl unten einen Artikel aus, um mehr zu erfahren",
        it: "Seleziona un articolo qui sotto per saperne di più. ",

    }
    }
    ,
    productsList: [
      {
        name: {
          fr: "A Minecraft Movie Meal",
          de: "A Minecraft Movie Meal",
          it: "A Minecraft Movie Meal",
        },
        desc: {
          fr: "Choisis ton Menu Medium et construis ton Minecraft Movie Meal. C’est le combo parfait si tu as une grosse faim après ton ciné pour les fans du jeu vidéo.",
          de: "Wähle dein Menu Medium und stelle dein Minecraft Movie Meal zusammen. Es ist das perfekte Combo, wenn du nach dem Kino grossen Hunger hast, für die Fans des Videospiels.",
          it: "Scegli il tuo Menu Medium e costruisci il tuo Minecraft Movie Meal. È il combo perfetto se hai una gran fame dopo il cinema per i fan del videogioco.",
        },
        cta: {
          fr: "C'est mon menu !",
          de: "Jetzt bestellen.",
          it: "È il menu per me!",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
        },
        multiple:'',
        img: "/img/Day_Splash_Image-copie.png",
      },
      {
        name: {
          fr: "Collectionne des figurines exclusives ",
          de: "Sammle exklusive Figuren",
          it: "Raccogli personaggi esclusivi ",
        },
        desc: {
          fr: "Chaque A Minecraft Movie Meal contient l’une des six figurines à collectionner trop cools.",
          de: "Jedes A Minecraft Movie Meal kommt mit einer von sechs coolen Sammelfiguren: ",
          it: "Scegli il tuo Menu Medium e costruisci il tuo Minecraft Movie Meal. È il combo perfetto se hai una gran fame dopo il cinema per i fan del videogioco.",
        },
        cta: {
          fr: "Je commence ma collection ! ",
          de: "Jetzt bestellen.",
          it: "Ordina subito.",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
        multiple:'true',
        img: "/img/Day_Splash_Image-copie.png",
      },
      {
        name: {
          fr: "Sauce Nether Flame ",
          de: "Nether Flame Sauce ",
          it: "Salsa Nether Flame ",
        },
        desc: {
          fr: "Tu aimes quand ça pique ? Si c’est le cas, cette sauce est faite pour toi : poivre rouge, piment de Cayenne, ail et une touche sucrée - parfaite avec tes Chicken  McNuggets®.",
          de: "Du magst es scharf? Dann ist diese Sauce wie für dich gemacht: Roter Pfeffer, Cayenne, Knoblauch und ein Hauch Süsse - perfekt zu deinen McChicken Nuggets.® ",
          it: "Ti piace il piccante? Allora questa salsa è fatta apposta per te! Pepe rosso e di Cayenna, aglio e un pizzico di dolcezza: un mix perfetto per i tuoi Chicken McNuggets.® ",
        },
        multiple:'',
        cta: {
          fr: "Prêt à la tester ?",
          de: "Erfahre mehr",
          it: "Scopri di più",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
        img: "/img/29984_Master1a_NetherSauce_Left_Twilight_r2_72.png",
      },
      {
        name: {
          fr: "McFlurry et Sundae A Minecraft Movie ",
          de: "A Minecraft Movie McFlurry & Sundae ",
          it: "A Minecraft Movie McFlurry & Sundae",
        },
        desc: {
          fr: "Nos desserts adorés, nappés d’une délicieuse sauce saveur pomme acidulée. Et le McFlurry est servi aussi avec des cubes de chocolat, façon Minecraft. ",
          de: "Unsere beliebten Desserts, getoppt mit der superfeinen Apple Sour-Sauce. Und der McFlurry erst noch mit Schoko-Cubes im Minecraft-Style. ",
          it: "I nostri famosi dessert, guarniti con la squisita salsa Apple Sour. Per non parlare del McFlurry con cubetti di cioccolato in stile Minecraft. ",
        },
        cta: {
          fr: "Je commande !",
          de: "Erfahre mehr",
          it: "Scopri di più",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
        multiple:'',
        img: "/img/McFlurry 1.png",
      },
      
    ],
  
    ctaVideo: {
      fr: "Voir la vidéo",
      de: "Entdecke das Video",
      it: "Scopri il video",
    },
  
    ctaBTn: [
      {
        name: {
          fr: "Goûte-le !",
          de: "Probiere es jetzt",
          it: "Assagialo subito",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
      },
    ],
  
    CommandeBTn: {
      fr: "Je commande maintenant",
      de: "Jetzt bestellen",
      it: "Ordino adesso",
    },
  
    CommandeBTnLinks: {
      fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
      de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
      it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
    },
  
    McCrispyData: [
      {
        title: {
          fr: "Dans ton Spicy McCrispy, il n'y a que du bon",
          de: "Alle guten Dinge in deinem Spicy McCrispy",
          it: "Tutto il meglio nel tuo Spicy McCrispy",
        },
        description: {
          fr: "D'accord, sa sauce épicée est incomparable. Mais le Spicy McCrispy te réserve bien d'autres délicieuses surprises.",
          de: "Klar, seine Spicy Sauce ist unübertroffen. Aber im Spicy McCrispy steckt noch viel mehr Feines.",
          it: "Ovvio, la sua salsa spicy è impareggiabile. Tuttavia, nello Spicy McCrispy trovi molte altre delizie.",
        },
      },
    ],
  
    metaData: {
      de: {
        title: "NEU! Spicy McCrispy – eine Geschmacksexplosion",
        description: "Stell dich der sehr spicy Challenge bei McDonald's Schweiz. Jetzt mit dem neuen Spicy McCrispy",
      },
      fr: {
        title: "NOUVEAU ! Spicy McCrispy, une explosion de saveurs",
        description: "Relève le défi très spicy qui t'attend chez McDonald's Suisse. Maintenant avec le nouveau Spicy McCrispy",
      },
      it: {
        title: "NOVITÀ! Spicy McCrispy: un'esplosione di gusto",
        description: "Accetta la sfida molto spicy che ti aspetta da McDonald's Svizzera. Ora con il nuovo Spicy McCrispy",
      },
    },
  
    merchandiseProductdetails: [
      {
        name: {
          fr: "Articles collector exclusifs pour les fans",
          de: "Exklusiver Merch für Fans ",
          it: "Merchandising esclusivo per i fan di Minecraft ",
        },
        desc: {
          fr: "À chaque fois que tu commandes dans l’app, tu reçois des points de fidélité que tu peux échanger contre des articles collector trop stylés dans notre fanshop. Découvre tout ce que tu peux avoir ! ",
          de: "Jedes Mal, wenn du in der App bestellst, gibt’s automatisch Loyalty-Punkte. In unserem Fanshop kannst du sie gegen coolen Merch tauschen. Schau jetzt, was dort alles auf dich wartet! ",
          it: "Ogni volta che ordini nell’app, ricevi automaticamente punti fedeltà, che puoi utilizzare nel nostro fanshop per ottenere fantastico merchandising. Scopri subito cosa ti aspetta! ",
        },
        cta: {
            fr: "Je vais dans le fanshop",
            de: "Ab in den Fanshop",
            it: "Vai al fanshop",
          },
          link: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
          img: "/img/pull-minecraft.jpg",
      },
      {
        name: {
          fr: "Happy Meal x A Minecraft Movie ",
          de: "Happy Meal x A Minecraft Movie ",
          it: "Happy Meal x A Minecraft Movie ",
        },
        desc: {
          fr: "Fan de A Minecraft Movie et de McDonald’s ? Alors nous avons exactement ce qu’il te faut : chaque A Minecraft Movie Meal contient l’une des 12 figurines à collectionner uniques. ",
          de: "Du liebst A Minecraft Movie und McDonald’s? Dann haben wir genau das Richtige: Jedes A Minecraft Movie Happy Meal kommt jetzt mit einer von 12 einmaligen Sammelfiguren. ",
          it: "Sei fan di Un film Minecraft e McDonald’s? Allora abbiamo quello che fa per te: in ogni A Minecraft Movie Happy Meal trovi uno dei 12 fantastici personaggi da collezionare. ",
        },
        cta: {
            fr: "Je veux en savoir plus !",
            de: "Ich will mehr wissen",
            it: "Voglio saperne di più",
          },
          link: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
          img: "/img/paquet.jpg",
      },
    ],
    
    // merchandiseListData: [
    //   {
    //     title: {
    //       fr: "Adopte le style Chicken !",
    //       de: "Wie wär's mit Chicken-Style?",
    //       it: "Ti piace lo stile Chicken?",
    //     },
    //     description: {
    //       fr: "Notre collection limitée Chicken Festival débarque bientôt ! Profites-en très prochainement dans ton app !",
    //       de: "Bald ist unsere limitierte Chicken Festival Kollektion da! Hol sie dir demnächst in deiner App!",
    //       it: "La nostra collezione limitata Chicken Festival sta in arrivo! Usa i tuoi punti nell'app per non fartela sfuggire.",
    //     },
    //   },
    // ],
  
    // merchandiseList: [
    //   {
    //     name: {
    //       fr: "Notre polo Chicken",
    //       de: "Unser Chicken-Polo",
    //       it: "Nostra polo Chicken.",
    //     },
    //     desc: {
    //       fr: "Parfait pour un style décontracté: notre polo en édition limitée sera bientôt dans l'app, mais ça ne va pas durer. Échange-le contre tes points.",
    //       de: "Perfekt für einen lässigen Chicken-Look: unser limitiertes Polo ist nur für kurze Zeit in der App. Löse es für diene Punkte ein.",
    //       it: "Perfetta per uno stile casual: la nostra polo in edizione limitata sarà disponibile presto nell'app, ma non durerà a lungo. Ottienila subito con i tuoi punti.",
    //     },
    //     cta: {
    //       fr: "Je le veux !",
    //       de: "Das will ich!",
    //       it: "La voglio!",
    //     },
    //     link: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
    //     img: "/img/paquet.png",
    //   },
    //   {
    //     name: {
    //       fr: "Notre casquette Chicken.",
    //       de: "Unsere Chicken-Cap.",
    //       it: "Nostro berretto Chicken.",
    //     },
    //     desc: {
    //       fr: "Ajoute une touche très cool à ton style avec notre casquette Chicken exclusive. Cet article en édition limitée sera uniquement disponible dans ton app. Utilise tes points !",
    //       de: "Runden deinen Style ab mit unserem exklusiven Chicken-Cap. Erhältlich wird das limitiere Piece nur in deiner App. Jetzt deine Punkte einlösen.",
    //       it: "Completa il tuo stile con il nostro esclusivo berretto Chicken. Questo articolo in edizione limitata sarà disponibile soltanto nella nostra app. Riscuoti ora i tuoi punti.",
    //     },
    //     cta: {
    //       fr: "À ne pas manquer !",
    //       de: "Nicht entgehen lassen!",
    //       it: "Non fartelo sfuggire!",
    //     },
    //     link: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-smartweb%253Fweburl%253Dhttps%25253A%25252F%25252Ffanshop.production.mcd-ch.platform-tbwa-x.com%25252F&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonaldsapps.com%2Ffr-CH%2F",
    //     img: "/img/pull-minecraft.png",
    //   },
    // ],
  
    TVCData: [
      {
        title: {
          fr: "Double tes points !",
          de: "Hol dir doppelte Punkte!",
          it: "Raddoppia i punti!",
        },
        description: {
          fr: "Savoure chacune de tes visites chez McDonald's avec notre nouveau Spicy McCrispy ou le délicieux McCrispy et double tes points dans l'app.",
          de: "Geniesse jeden Besuch bei McDonald's mit unserem neuen Spicy McCrispy oder dem leckeren McCrispy und verdoppele deine Punkte in der App.",
          it: "Assapora ogni visita da McDonald's con il nostro nuovo Spicy McCrispy o il delizioso McCrispy e raddoppia i tuoi punti nell'app.",
        },
        cta: {
          fr: "Je fonce !",
          de: "Jetzt zugreifen",
          it: "Da non perdere!",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
      },
    ],
  
    FAQ: [
      {
        name: {
          fr: "Lorem Ipsum",
          de: "Lorem Ipsum",
          it: "Lorem Ipsum",
        },
        description: {
          fr: "Tu as des questions sur A Minecraft Movie Meal ? Alors jette un œil à notre FAQ. ",
          de: "Du hast noch Fragen rund um’s A Minecraft Movie Meal? Dann schau dich in unseren FAQ um.",
          it: "Hai altre domande su A Minecraft Movie Meal? Dai un’occhiata alle nostre FAQ.",
        },
        btn: {
          fr: "FAQ",
          de: "FAQ",
          it: "FAQ",
        },
        link: {
          fr: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Ffr-ch%2Forderandpay.html",
          de: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fde-ch%2Forderandpay.html",
          it: "https://dg95h.app.goo.gl/?link=https%3A%2F%2Fwww.mcdonaldsapps.com%2F%3FappUrl%3Dgmalite%253A%252F%252Fgmalite-order&apn=com.mcdonalds.mobileapp&isi=1217507712&ibi=com.mcdonalds.mobileapp&ofl=https%3A%2F%2Fwww.mcdonalds.com%2Fch%2Fit-ch%2Forderandpay.html",
        },
      },
    ],
  };
  
  export const basePath = window.location.pathname.includes("/minecraft.dev")
    ? "/minecraft.dev"
    : "";